import React, { useContext, useEffect, useState } from 'react';
import AuthContext from '../contexts/AuthContext';
import { IoLogOut, IoMenu } from "react-icons/io5";
import { MdFace, MdOutlineWbSunny } from "react-icons/md";
import { IoMoonSharp } from "react-icons/io5";
import { MdOutlineGridView } from "react-icons/md";
import { FaEdit, FaRegBell, FaUnlockAlt, FaUser } from "react-icons/fa";
import { LuSettings2 } from "react-icons/lu";
import { FaSearch } from "react-icons/fa";
import { IoMdLock } from "react-icons/io";
import { FaIndianRupeeSign } from 'react-icons/fa6';
import ClearOutstanding from '../pages/Header_Pages/Clear Outstanding';
import ChangePassword from '../pages/Header_Pages/Change_Password';

import 'react-toastify/dist/ReactToastify.css';
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom';

function Header() {
  const { logout } = useContext(AuthContext);
  const [DarkMod, setDarkMod] = useState(true);

  const [isModalOpen, setIsModalOpen] = useState(false);

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  // *************************************************************************************************************************
  const [isPassModalOpen, setIsPassModalOpen] = useState(false);

  const toggleModal2 = () => {
    setIsPassModalOpen(!isPassModalOpen);
  };


  return (
    <>
      <header id="page-topbar">

        <ChangePassword isOpen={isPassModalOpen} onClose={toggleModal2} />
        <ClearOutstanding isOpen={isModalOpen} onClose={toggleModal} />

        <div className="navbar-header">
          <div className="d-flex">
            {/* LOGO */}
            <div className="navbar-brand-box">
              <a href="#" className="logo logo-dark">
                <span className="logo-sm">
                  <img src={"../assets/images/MMB_LOGO/MMB_LOGO.png"} alt="" height={30} />
                </span>
                <span className="logo-lg">
                  <img src={"../assets/images/MMB_LOGO/MMB_LOGO.png"} alt="" height={30} />{" "}
                  <span className="logo-txt ms-3">MMB</span>
                </span>
              </a>
              <a href="#" className="logo logo-light">
                <span className="logo-sm">
                  <img src={"../assets/images/MMB_LOGO/MMB_LOGO.png"} alt="" height={30} />
                </span>
                <span className="logo-lg">
                  <img src={"../assets/images/MMB_LOGO/MMB_LOGO.png"} alt="" height={30} />{" "}
                  <span className="logo-txt ms-3">MMB</span>
                </span>
              </a>
            </div>
            <button
              type="button"
              className="btn btn-sm px-3 font-size-16 header-item"
              id="vertical-menu-btn"
            >
              < IoMenu />
            </button>
            {/* App Search*/}
            {/* <form className="app-search d-none d-lg-block">
            <div className="position-relative">
              <input type="text" className="form-control" placeholder="Search..." />
              <button className="btn btn-primary" type="button">
                < FaSearch />
              </button>
            </div>
          </form> */}
          </div>
          <div className="d-flex">
            <div className="dropdown d-inline-block d-lg-none ms-2">
              <button
                type="button"
                className="btn header-item"
                id="page-header-search-dropdown"
                data-bs-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <i data-feather="search" className="icon-lg" />
              </button>
              <div
                className="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0"
                aria-labelledby="page-header-search-dropdown"
              >
                <form className="p-3">
                  <div className="form-group m-0">
                    <div className="input-group">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Search ..."
                        aria-label="Search Result"
                      />
                      <button className="btn btn-primary" type="submit">
                        <i className="mdi mdi-magnify" />
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>

            {/* Here is the Select Country */}

            {/* <div className="dropdown d-none d-sm-inline-block">
            <button
              type="button"
              className="btn header-item"
              data-bs-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <img
                id="header-lang-img"
                src="assets/images/flags/us.jpg"
                alt="Header Language"
                height={16}
              />
            </button>
            <div className="dropdown-menu dropdown-menu-end">
              
              <a
                href="#"
                className="dropdown-item notify-item language"
                data-lang="en"
              >
                <img
                  src="assets/images/flags/us.jpg"
                  alt="user-image"
                  className="me-1"
                  height={12}
                />{" "}
                <span className="align-middle">English</span>
              </a>
              
              <a
                href="#"
                className="dropdown-item notify-item language"
                data-lang="sp"
              >
                <img
                  src="assets/images/flags/spain.jpg"
                  alt="user-image"
                  className="me-1"
                  height={12}
                />{" "}
                <span className="align-middle">Spanish</span>
              </a>
              
              <a
                href="#"
                className="dropdown-item notify-item language"
                data-lang="gr"
              >
                <img
                  src="assets/images/flags/germany.jpg"
                  alt="user-image"
                  className="me-1"
                  height={12}
                />{" "}
                <span className="align-middle">German</span>
              </a>
              
              <a
                href="#"
                className="dropdown-item notify-item language"
                data-lang="it"
              >
                <img
                  src="assets/images/flags/italy.jpg"
                  alt="user-image"
                  className="me-1"
                  height={12}
                />{" "}
                <span className="align-middle">Italian</span>
              </a>
              
              <a
                href="#"
                className="dropdown-item notify-item language"
                data-lang="ru"
              >
                <img
                  src="assets/images/flags/russia.jpg"
                  alt="user-image"
                  className="me-1"
                  height={12}
                />{" "}
                <span className="align-middle">Russian</span>
              </a>
            </div>
          </div> */}

            <div className="dropdown d-sm-inline-block" >
              <button style={{ fontSize: '18px' }} type="button"
                className="btn header-item" id="mode-setting-btn" onClick={() => setDarkMod(!DarkMod)}>
                {DarkMod ? <IoMoonSharp style={{ pointerEvents: 'none' }} />
                  : <MdOutlineWbSunny style={{ pointerEvents: 'none' }} />}
              </button>
            </div>

            {/* Here is the platforms */}
            <div className="dropdown d-lg-inline-block ms-1">
              <button
                type="button"
                className="btn header-item"
                data-bs-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
                style={{ fontSize: '20px' }}
              >
                <MdOutlineGridView />
              </button>


              <div className="dropdown-menu dropdown-menu-end" style={{ width: '400px' }}>
                <div className="p-2">
                  <div className="row g-0">
                    <div onClick={toggleModal} className="col">
                      <a className="dropdown-icon-item" href="#">
                        {/* <img src="assets/images/brands/github.png" alt="Github" /> */}
                        <FaIndianRupeeSign style={{ fontSize: '24px', color: '#007EE6' }} />
                        <span>Clear Outstanding</span>
                      </a>
                    </div>
                    <div className="col">
                        <Link to="/balance_up_req">

                      <a className="dropdown-icon-item" href="#">
                        {/* <img
                        src="assets/images/brands/bitbucket.png"
                        alt="bitbucket"
                      /> */}
                        <FaEdit style={{ fontSize: '24px', color: '#E44582' }} />
                        <span >Update Request</span>
                      </a>
                      </Link>
                    </div>

                    <div onClick={toggleModal2} className="col">
                      <a className="dropdown-icon-item" href="#">
                        {/* <img src="assets/images/brands/dribbble.png" alt="dribbble" /> */}
                        <FaUnlockAlt style={{ fontSize: '24px', color: '#3EB991' }} />
                        <span>Change Password</span>
                      </a>
                    </div>
                  </div>
                  {/* <div className="row g-0">
                  <div className="col">
                    <a className="dropdown-icon-item" href="#">
                      <img src="assets/images/brands/dropbox.png" alt="dropbox" />
                      <span>Dropbox</span>
                    </a>
                  </div>
                  <div className="col">
                    <a className="dropdown-icon-item" href="#">
                      <img
                        src="assets/images/brands/mail_chimp.png"
                        alt="mail_chimp"
                      />
                      <span>Mail Chimp</span>
                    </a>
                  </div>
                  <div className="col">
                    <a className="dropdown-icon-item" href="#">
                      <img src="assets/images/brands/slack.png" alt="slack" />
                      <span>Slack</span>
                    </a>
                  </div>
                </div> */}
                </div>
              </div>

            </div>


            {/* Here is the Notification Bell */}
            {/* <div className="dropdown d-inline-block">
            <button
              type="button"
              className="btn header-item noti-icon position-relative"
              id="page-header-notifications-dropdown"
              data-bs-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
              style={{ fontSize: '20px' }}
            >
              <FaRegBell />
              <span style={{ fontSize: '11px' }} className="badge bg-danger rounded-pill mt-1">5</span>
            </button>
            <div
              className="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0"
              aria-labelledby="page-header-notifications-dropdown"
            >
              <div className="p-3">
                <div className="row align-items-center">
                  <div className="col">
                    <h6 className="m-0"> Notifications </h6>
                  </div>
                  <div className="col-auto">
                    <a
                      href="#"
                      className="small text-reset text-decoration-underline"
                    >
                      {" "}
                      Unread (3)
                    </a>
                  </div>
                </div>
              </div>
              <div data-simplebar="" style={{ maxHeight: 230 }}>
                <a href="#" className="text-reset notification-item">
                  <div className="d-flex">
                    <div className="flex-shrink-0 me-3">
                      <img
                        src="assets/images/users/avatar-3.jpg"
                        className="rounded-circle avatar-sm"
                        alt="user-pic"
                      />
                    </div>
                    <div className="flex-grow-1">
                      <h6 className="mb-1">James Lemire</h6>
                      <div className="font-size-13 text-muted">
                        <p className="mb-1">
                          It will seem like simplified English.
                        </p>
                        <p className="mb-0">
                          <i className="mdi mdi-clock-outline" />{" "}
                          <span>1 hour ago</span>
                        </p>
                      </div>
                    </div>
                  </div>
                </a>
                <a href="#" className="text-reset notification-item">
                  <div className="d-flex">
                    <div className="flex-shrink-0 avatar-sm me-3">
                      <span className="avatar-title bg-primary rounded-circle font-size-16">
                        <i className="bx bx-cart" />
                      </span>
                    </div>
                    <div className="flex-grow-1">
                      <h6 className="mb-1">Your order is placed</h6>
                      <div className="font-size-13 text-muted">
                        <p className="mb-1">
                          If several languages coalesce the grammar
                        </p>
                        <p className="mb-0">
                          <i className="mdi mdi-clock-outline" />{" "}
                          <span>3 min ago</span>
                        </p>
                      </div>
                    </div>
                  </div>
                </a>
                <a href="#" className="text-reset notification-item">
                  <div className="d-flex">
                    <div className="flex-shrink-0 avatar-sm me-3">
                      <span className="avatar-title bg-success rounded-circle font-size-16">
                        <i className="bx bx-badge-check" />
                      </span>
                    </div>
                    <div className="flex-grow-1">
                      <h6 className="mb-1">Your item is shipped</h6>
                      <div className="font-size-13 text-muted">
                        <p className="mb-1">
                          If several languages coalesce the grammar
                        </p>
                        <p className="mb-0">
                          <i className="mdi mdi-clock-outline" />{" "}
                          <span>3 min ago</span>
                        </p>
                      </div>
                    </div>
                  </div>
                </a>
                <a href="#" className="text-reset notification-item">
                  <div className="d-flex">
                    <div className="flex-shrink-0 me-3">
                      <img
                        src="assets/images/users/avatar-6.jpg"
                        className="rounded-circle avatar-sm"
                        alt="user-pic"
                      />
                    </div>
                    <div className="flex-grow-1">
                      <h6 className="mb-1">Salena Layfield</h6>
                      <div className="font-size-13 text-muted">
                        <p className="mb-1">
                          As a skeptical Cambridge friend of mine occidental.
                        </p>
                        <p className="mb-0">
                          <i className="mdi mdi-clock-outline" />{" "}
                          <span>1 hour ago</span>
                        </p>
                      </div>
                    </div>
                  </div>
                </a>
              </div>
              <div className="p-2 border-top d-grid">
                <a
                  className="btn btn-sm btn-link font-size-14 text-center"
                  href="javascript:void(0)"
                >
                  <i className="mdi mdi-arrow-right-circle me-1" />{" "}
                  <span>View More..</span>
                </a>
              </div>
            </div>
          </div> */}

            {/* Here is the Costomiser panal  */}
            {/* <div className="dropdown d-inline-block">
            <button style={{ fontSize: '20px' }} type="button" className="btn header-item right-bar-toggle me-2">
              < LuSettings2 />
            </button>
          </div> */}

            <div className="dropdown d-inline-block ">
              <button
                type="button"
                className="btn header-item bg-light-subtle border-start border-end loginProfile"
                id="page-header-user-dropdown"
                data-bs-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <img
                  className="rounded-circle header-profile-user"
                  src="assets/images/users/avatar-1.jpg"
                  alt="IMG"
                />
                {/* <FaUser /> */}
                
                <span className="d-none d-xl-inline-block ms-1 fw-medium">
                  Admin
                </span>
                <i className="mdi mdi-chevron-down d-none d-xl-inline-block" />
              </button>
              <div className="dropdown-menu dropdown-menu-end">
                {/* item*/}
                {/* <a style={{ fontSize: '17px' }} className="dropdown-item" href="apps-contacts-profile.html">
                  <MdFace />{" "}
                  Profile
                </a> */}
                {/* <a style={{ fontSize: '17px' }} className="dropdown-item" href="auth-lock-screen.html">
                  <IoMdLock /> Lock
                  Screen
                </a> */}
                <div className="dropdown-divider" />
                <a style={{ fontSize: '17px' }} className="dropdown-item" onClick={() => logout()}>
                  <IoLogOut />{" "}
                  Logout
                </a>
              </div>
            </div>
          </div>
        </div>
      </header>


    </>
  );
}
export default Header;
